import React, {createContext, useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {i18n} from '@/settings';
import split from 'lodash/split';

const InternationalizationContext = createContext();

export const getSimpleLocale = v => split(v, '-')[0];

function InternationalizationProvider({children, defaultLanguage}) {
  const [locale, updateLocale] = useState(defaultLanguage);

  useEffect(() => {
    updateLocale(defaultLanguage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguage]);

  return (
    <InternationalizationContext.Provider value={{
      locale,
      updateLocale,
    }}>
      {children}
    </InternationalizationContext.Provider>
  );
}

function useInternationalization() {
  const context = useContext(InternationalizationContext);
  if (context === undefined) {
    throw new Error('useInternationalization must be used within a InternationalizationProvider');
  }

  const {
    locale,
    updateLocale
  } = context;

  return {
    locale,
    updateLocale
  };
}

InternationalizationProvider.propTypes = {
  children: PropTypes.any,
  defaultLanguage: PropTypes.string,
};

InternationalizationProvider.defaultProps = {
  defaultLanguage: getSimpleLocale(i18n?.language) || '',
};


export {InternationalizationProvider, useInternationalization};
